import React, { useState, useEffect, useMemo } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import ListPage from '../Components/ListPage/ListPage';
import Controllers from '../Api/Controllers';
import { useSelector } from 'react-redux';
import { Select } from '../Components/Form/Form';
import Button from 'react-bootstrap/Button';

const ReportResolution = () => {
  const nameModulo = 'Resoluciones'
  const currentYear = useSelector(store => store.session.year)

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [reload, setReload] = useState(true);
  const [unit, setUnit] = useState([])
  const [unitSelected, setUnitSelected] = useState('')
  /* const [state, setState] = useState(-1) */
  const [file, setFile] = useState('')

  /* const optionsState = [
    { value: -1, label: 'TODAS' },
    { value: 0, label: 'PENDIENTE' },
    { value: 1, label: 'PENDIENTE DE APROBACIÓN' },
    { value: 2, label: 'RECHAZADO' },
    { value: 3, label: 'CONSOLIDADO' }
  ] */

  useEffect(() => {
    Controllers.unit.get_unit_public_with_pack({
      p_year: currentYear
    }).then(res => {
      res.data.unshift({
        id: '',
        description: 'TODAS'
      })
      setUnit(res.data)
      /* if (res.data.length === 2) {
        let unitFind = res.data.find(e => e.id !== '')
        if (unitFind) {
          setUnitSelected(unitFind.id)
        }
      } */
    })
  }, [currentYear])

  useEffect(() => {
    if (reload) {
      Controllers.packs_annual.get_pac_resolution().then(res => {
        setRows(res.data.data)
        setFile({
          file: res.data.file,
          name: res.data.filename
        })
      })
      .finally(() => {
        setIsProcessing(false)
        setReload(false);
      });
    }
  }, [reload])

  const cboUnit = useMemo(() => {
    let unitFind = unit.find(u => u.id === unitSelected)

    return <Select
      value={unitFind ? {value: unitFind.id, label: unitFind.id + (unitFind.id ? ' - ' : '') + unitFind.description} : ''}
      options={unit.map(s => {
        return {
          value: s.id,
          label: s.id + (s.id ? ' - ' : '') + s.description
        }
      })}
      onChange={e => {
        setUnitSelected(e.value)
        setReload(true)
      }}
      text="Centro de costo"
      icon="far fa-building"
      classNameParent="col-12 col-md-6 mb-2"
    />
  }, [unit, unitSelected])

  const dtRows = useMemo(() => {
    const thead = [
      { name: 'Número', align: 'center' },
      { name: 'Año', align: 'center' },
      { name: 'Centro Costo', align: 'center' },
      { name: 'Numero Resolución', align: 'center' },
      { name: 'MODIFICACIÓN PRESUPUESTARIA' },
      { name: 'Fecha Aprobación', align: 'center' },
    ];

    return <DataTable
      columnOrder={3}
      isProcessing={isProcessing}
      tbody={rows.map(r => {
        return {
          number: parseInt(r.number),
          year: parseInt(r.year),
          unit: r.id_unit + ' - ' + r.description,
          number_resolution: parseInt(r.number_resolution),
          extension_budget: r.extension_budget,
          date_resolution: r.date_resolution
        }
      }).filter(r => {
        if (!isNaN(parseInt(unitSelected))) {
          return r.unit.includes(unitSelected)
        }
        return r
      })}
      thead={thead}
      render={tbody => tbody.map(r => {
        let rowRender = [];
        let i = 0;
        for (let key in r) {
          if (key === 'state') {
            rowRender.push(<td align={thead[i].align ? thead[i].align : ''} className={'text-' + (parseInt(r.state) === 0 ? 'warning' : (parseInt(r.state) === 1 ? 'info' : (parseInt(r.state) === 2 ) ? 'danger' : 'success'))}>
                <strong>{parseInt(r.state) === 0 ? 'PENDIENTE' : (parseInt(r.state) === 1 ? 'PENDIENTE DE CONSOLIDACIÓN' : (parseInt(r.state) === 2 ) ? 'RECHAZADO' : 'CONSOLIDADO')}</strong>
              </td>);
          } else if (key === 'state_purchase') {
            let color = ''
            let texto = ''
            switch (parseInt(r.state_purchase)) {
              case 0:
                color = 'warning'
                texto = 'SIN ORDEN DE COMPRA'
                break;
              case 1:
                color = 'info'
                texto = 'CON ORDEN DE COMPRA'
                break;
              case 2:
                color = 'primary'
                texto = 'COMPROMISO'
                break;
              case 3:
                color = 'dark'
                texto = 'COMPLETADO'
                break;
              case 4:
                color = 'info'
                texto = 'DEVENGADO'
                break;
              case 5:
                color = 'primary'
                texto = 'ENVIADO DAF'
                break;
              case 6:
                color = 'danger'
                texto = 'RECHAZADO'
                break;
              case 7:
                color = 'success'
                texto = 'PAGADO'
                break;
              case 8:
                color = 'danger'
                texto = 'ANULADO'
                break;
              case 9:
                color = 'primary'
                texto = 'CON DOCUMENTACIÓN';
                break;
              default:
                break;
            }
                
            rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
            <strong className={'text-' + color}>{texto}</strong></td>)
          } else if (key === 'extension_budget') {
            rowRender.push(<td align="center">
              <div className={'badge badge-' + (parseInt(r.extension_budget) === 1 ? 'success' : 'danger')}>
                {parseInt(r.extension_budget) === 1 ? 'SI' : 'NO'}
              </div>
            </td>);
          }
          else {
            rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>{r[key]}</td>);
          }
          i++;
        }

        return (<tr>
          {React.Children.toArray(rowRender)}
        </tr>);
      })}
    />
  }, [isProcessing, rows, unitSelected, /* state */])

  return <> 
    <ListPage
      title={<>Listado De {nameModulo}</>}
      subtitle="Gestioná el listado y las acciones disponibles."
    >
      {file ? <a href={file.file} download={file.name}>
          <Button size="sm" variant="success" className="mb-2"><i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel</Button>
        </a> : ''}
        <div className="form-row">
          {cboUnit}
          {/* <Select
            defaultValue={optionsState.find(o => o.value === state)}
            classNameParent="col-12 col-md-6"
            icon="fa fa-list"
            text="Estado"
            options={optionsState}
            onChange={e => setState(e.value)}
          /> */}
        </div>
        {dtRows}
    </ListPage>
  </>
}

export default ReportResolution;